import {
    tss,
} from 'app/tss'

export default tss.create({
    chart: {
        height: '80%',
        transition: 'width 0.2s ease-in',
    },
    rangeFilter: {
        height: '20%',
    },
})
